import React from 'react';
import { Helmet } from 'react-helmet';

interface IPage {
  title: string
  children?: React.ReactNode
  className?: string
}

const Page = ({ title, children, className, ...rest }: IPage) => {
  return (
    <div {...rest} className={className}>
      <Helmet>
        <meta charSet="utf-8" />
        {(process.env.NODE_ENV === "production" || process.env.NODE_ENV === "development") &&
          <title>MySimec | {title}</title>
        }
        {process.env.NODE_ENV !== "development" && process.env.NODE_ENV !== 'production' &&
          <title>MySimec staging | {title}</title>
        }
      </Helmet>
      {children}
    </div>
  );
};

export default Page;
